import Button from "@/components/button";
import { useTheme } from "@mui/material";

interface AddToCartButtonProps {
  onClick: () => void;
  disabled: boolean;
  submitting: boolean;
  variant?: "mobile" | "desktop";
}

export const AddToCartButton = ({
  onClick,
  disabled,
  submitting,
  variant = "mobile",
}: AddToCartButtonProps) => {
  const height = variant === "mobile" ? 48 : 52;
  const theme = useTheme();

  return (
    <Button
      data-cypress="add-to-cart-button"
      onClick={onClick}
      variant="contained"
      sx={{
        width: "100%",
        height,
        background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark || theme.palette.secondary.main} 100%)`,
        borderRadius: 2,
        fontSize: 16,
        fontWeight: 700,
        textTransform: "none",
        boxShadow: `0 4px 12px ${theme.palette.secondary.main}4D`,
        border: "1px solid rgba(255, 255, 255, 0.2)",
        transition: "all 0.3s ease-in-out",
        "&:hover": {
          background: `linear-gradient(135deg, ${theme.palette.secondary.dark || theme.palette.secondary.main} 0%, ${theme.palette.secondary.main} 100%)`,
          transform: "translateY(-2px)",
          boxShadow: `0 8px 20px ${theme.palette.secondary.main}66`,
        },
        "&:active": {
          transform: "translateY(0)",
        },
        "&:disabled": {
          background: "rgba(0, 0, 0, 0.12)",
          color: "rgba(0, 0, 0, 0.26)",
          transform: "none",
          boxShadow: "none",
        },
      }}
      disabled={disabled}
    >
      {submitting
        ? "Adding to Cart..."
        : disabled
          ? "Loading Pricing"
          : "Add To Cart"}
    </Button>
  );
};
